(function () {
  'use strict';

  if (window.__rgAugustGiveawayInitialized) return;
  window.__rgAugustGiveawayInitialized = true;

  var ENTRY_STORAGE_KEY = 'rgAugustGiveawayEntry2026';
  var POPUP_CLOSED_KEY = 'rgAugustGiveawayPopupClosed2026';
  var POPUP_SESSION_KEY = 'rgAugustGiveawayPopupSeen2026';

  function safeJsonParse(value) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }

  function getStoredEntry() {
    try {
      return safeJsonParse(localStorage.getItem(ENTRY_STORAGE_KEY));
    } catch (error) {
      return null;
    }
  }

  function setStoredEntry(entry) {
    try {
      localStorage.setItem(ENTRY_STORAGE_KEY, JSON.stringify(entry));
    } catch (error) {}
  }

  function deadlinePassed(root) {
    var deadline = root.getAttribute('data-deadline');
    return deadline ? Date.now() >= new Date(deadline).getTime() : false;
  }

  function setStatus(form, message, state) {
    var status = form.querySelector('[data-rg-status]');
    if (!status) return;
    status.textContent = message || '';
    status.setAttribute('data-state', state || '');
  }

  function setBusy(button, busy, busyLabel) {
    if (!button) return;
    if (busy) {
      button.dataset.originalLabel = button.textContent;
      button.textContent = busyLabel || 'Saving…';
      button.disabled = true;
    } else {
      button.textContent = button.dataset.originalLabel || button.textContent;
      button.disabled = false;
    }
  }

  function profileProperties(source, entry) {
    var properties = {
      'RGM Giveaway Campaign': 'August 2026',
      'RGM August Giveaway Entered': true,
      'RGM August Giveaway Base Entries': 1,
      'RGM August Giveaway Entry Source': source,
      'RGM August Giveaway Eligible US 18+': true,
      'RGM August Giveaway Entry Date': entry.entryDate || new Date().toISOString()
    };

    if (entry.shared) {
      properties['RGM August Giveaway Shared'] = true;
      properties['RGM August Giveaway Share Entries'] = 5;
      properties['RGM August Giveaway Share Platform'] = entry.sharePlatform || '';
      properties['RGM August Giveaway Share Date'] = entry.shareDate || new Date().toISOString();
    }

    if (entry.crystalAscensionMember) {
      properties['RGM August Giveaway Crystal Ascension Member'] = true;
      properties['RGM August Giveaway Crystal Ascension Entries'] = 5;
      properties['RGM August Giveaway Crystal Ascension Date'] =
        entry.crystalAscensionDate || new Date().toISOString();
    }

    return properties;
  }

  async function subscribe(root, entry) {
    var listId = root.getAttribute('data-klaviyo-list-id');
    var source = root.getAttribute('data-entry-source') || 'Giveaway page';
    var properties = profileProperties(source, entry);
    var fields = Object.keys(properties);
    var body = new URLSearchParams({
      g: listId,
      email: entry.email,
      '$first_name': entry.firstName,
      '$last_name': entry.lastName,
      '$source': 'Royal Gems August Monthly Giveaway - ' + source,
      '$fields': fields.join(',')
    });

    fields.forEach(function (field) {
      body.set(field, String(properties[field]));
    });

    var response = await fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
      method: 'POST',
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      },
      body: body.toString()
    });

    var result = await response.json();
    if (!response.ok || !result.success) {
      throw new Error('Entry service returned ' + response.status);
    }
  }

  function bonusEntryCount(entry) {
    return 1 + (entry && entry.shared ? 5 : 0) + (entry && entry.crystalAscensionMember ? 5 : 0);
  }

  function updateBonusPanel(form, panel, entry) {
    if (!panel) return;
    var shareCopy = panel.querySelector('[data-rg-share-copy]');
    var shareActions = panel.querySelector('[data-rg-share-actions]');
    var groupBonus = panel.querySelector('[data-rg-group-bonus]');
    if (shareCopy) shareCopy.hidden = Boolean(entry.shared);
    if (shareActions) shareActions.hidden = Boolean(entry.shared);
    if (groupBonus) groupBonus.hidden = Boolean(entry.crystalAscensionMember);
    panel.hidden = Boolean(entry.shared && entry.crystalAscensionMember);
  }

  function revealShare(form, entry) {
    var panel = form.querySelector('[data-rg-share-panel]');
    if (!panel) return;
    panel.hidden = false;
    panel.dataset.entryEmail = entry.email;
    panel.dataset.entryFirstName = entry.firstName;
    panel.dataset.entryLastName = entry.lastName;
    panel.dataset.entryDate = entry.entryDate || '';
    panel.dataset.entryShared = entry.shared ? 'true' : 'false';
    panel.dataset.entrySharePlatform = entry.sharePlatform || '';
    panel.dataset.entryShareDate = entry.shareDate || '';
    panel.dataset.entryCrystalAscensionMember = entry.crystalAscensionMember ? 'true' : 'false';
    panel.dataset.entryCrystalAscensionDate = entry.crystalAscensionDate || '';
    updateBonusPanel(form, panel, entry);
    var heading = panel.querySelector('h3');
    if (heading) heading.setAttribute('tabindex', '-1');
    if (heading) heading.focus({ preventScroll: true });
  }

  function getEntryFromSharePanel(panel) {
    return {
      email: panel.dataset.entryEmail || '',
      firstName: panel.dataset.entryFirstName || '',
      lastName: panel.dataset.entryLastName || '',
      entryDate: panel.dataset.entryDate || '',
      shared: panel.dataset.entryShared === 'true',
      sharePlatform: panel.dataset.entrySharePlatform || '',
      shareDate: panel.dataset.entryShareDate || '',
      crystalAscensionMember: panel.dataset.entryCrystalAscensionMember === 'true',
      crystalAscensionDate: panel.dataset.entryCrystalAscensionDate || ''
    };
  }

  function shareUrl(root) {
    return root.getAttribute('data-giveaway-url') || window.location.href.split('#')[0];
  }

  function shareText() {
    return 'Enter the Royal Gems August Monthly Giveaway for a chance to win a Serpentine Hippo Bowl filled with surprise goodies!';
  }

  function initializeShareThanks(form) {
    var overlay = form.querySelector('[data-rg-share-thanks]');
    if (!overlay || overlay.dataset.rgInitialized === 'true') return;
    overlay.dataset.rgInitialized = 'true';
    var dialog = overlay.querySelector('[role="dialog"]');
    var previousFocus = null;

    function focusable() {
      return Array.prototype.slice.call(
        overlay.querySelectorAll('button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return element.offsetParent !== null;
      });
    }

    function close() {
      overlay.hidden = true;
      document.body.classList.remove('rg-giveaway-share-thanks-open');
      if (
        previousFocus &&
        previousFocus.focus &&
        previousFocus.isConnected &&
        previousFocus.offsetParent !== null
      ) {
        previousFocus.focus();
      } else {
        var status = form.querySelector('[data-rg-status]');
        if (status) {
          status.setAttribute('tabindex', '-1');
          status.focus();
        }
      }
    }

    overlay._rgShowShareThanks = function () {
      previousFocus = document.activeElement;
      overlay.hidden = false;
      document.body.classList.add('rg-giveaway-share-thanks-open');
      window.setTimeout(function () {
        if (dialog) dialog.focus();
      }, 40);
    };

    overlay.querySelectorAll('[data-rg-share-thanks-close]').forEach(function (button) {
      button.addEventListener('click', close);
    });
    overlay.addEventListener('click', function (event) {
      if (event.target === overlay) close();
    });
    overlay.addEventListener('keydown', function (event) {
      if (overlay.hidden) return;
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      var elements = focusable();
      if (!elements.length) return;
      var first = elements[0];
      var last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function showShareThanks(form, message) {
    var overlay = form.querySelector('[data-rg-share-thanks]');
    var messageElement = overlay && overlay.querySelector('[data-rg-bonus-thanks-message]');
    if (messageElement && message) messageElement.textContent = message;
    if (overlay && overlay._rgShowShareThanks) overlay._rgShowShareThanks();
  }

  async function recordShare(root, form, panel, platform, button) {
    var entry = getEntryFromSharePanel(panel);
    if (!entry.email) {
      setStatus(form, 'Please enter first so we can attach the bonus entries to your name.', 'error');
      return;
    }

    var previousEntry = getStoredEntry();
    if (previousEntry && previousEntry.shared) {
      revealShare(form, previousEntry);
      setStatus(form, 'Your share entries are already saved. You have ' + bonusEntryCount(previousEntry) + ' total entries.', 'success');
      return;
    }

    setBusy(button, true, 'Adding 5 entries…');
    try {
      var stored = getStoredEntry() || entry;
      stored.shared = true;
      stored.sharePlatform = platform;
      stored.shareDate = new Date().toISOString();
      await subscribe(root, stored);
      setStoredEntry(stored);
      setBusy(button, false);
      revealShare(form, stored);
      setStatus(form, 'Your share bonus is saved. You now have ' + bonusEntryCount(stored) + ' total entries.', 'success');
      showShareThanks(form, 'Your five sharing bonus entries are saved. Good luck in the drawing!');
    } catch (error) {
      setStatus(form, 'Your main entry is saved, but the share entries did not save yet. Please try again.', 'error');
      setBusy(button, false);
      return;
    }
  }

  async function recordCrystalAscension(root, form, panel, button) {
    var entry = getEntryFromSharePanel(panel);
    if (!entry.email) {
      setStatus(form, 'Please enter first so we can attach the group bonus entries to your name.', 'error');
      return;
    }

    var stored = getStoredEntry() || entry;
    if (stored.crystalAscensionMember) {
      revealShare(form, stored);
      setStatus(form, 'Your Crystal Ascension entries are already saved. You have ' + bonusEntryCount(stored) + ' total entries.', 'success');
      return;
    }

    setBusy(button, true, 'Adding 5 entries…');
    try {
      stored.crystalAscensionMember = true;
      stored.crystalAscensionDate = new Date().toISOString();
      await subscribe(root, stored);
      setStoredEntry(stored);
      setBusy(button, false);
      revealShare(form, stored);
      setStatus(form, 'Your Crystal Ascension bonus is saved. You now have ' + bonusEntryCount(stored) + ' total entries.', 'success');
      showShareThanks(form, 'Your five Crystal Ascension bonus entries are saved. Good luck in the drawing!');
    } catch (error) {
      stored.crystalAscensionMember = false;
      stored.crystalAscensionDate = '';
      setStatus(form, 'Your main entry is saved, but the Crystal Ascension entries did not save yet. Please try again.', 'error');
      setBusy(button, false);
    }
  }

  function initializeForm(root, form) {
    if (form.dataset.rgInitialized === 'true') return;
    form.dataset.rgInitialized = 'true';
    initializeShareThanks(form);

    var closedMessage = form.querySelector('[data-rg-closed]');
    var formFields = form.querySelector('[data-rg-form-fields]');
    var storedEntry = getStoredEntry();

    if (deadlinePassed(root)) {
      if (formFields) formFields.hidden = true;
      if (closedMessage) closedMessage.hidden = false;
      return;
    }

    if (storedEntry && storedEntry.email) {
      revealShare(form, storedEntry);
      setStatus(form, 'Welcome back! You have ' + bonusEntryCount(storedEntry) + ' saved entr' + (bonusEntryCount(storedEntry) === 1 ? 'y.' : 'ies.'), 'success');
    }

    form.addEventListener('submit', async function (event) {
      event.preventDefault();

      if (deadlinePassed(root)) {
        if (formFields) formFields.hidden = true;
        if (closedMessage) closedMessage.hidden = false;
        return;
      }

      var honeypot = form.querySelector('[data-rg-honeypot]');
      if (honeypot && honeypot.value) return;

      if (!form.reportValidity()) return;

      var entry = {
        firstName: form.querySelector('[name="contact[first_name]"]').value.trim().slice(0, 80),
        lastName: form.querySelector('[name="contact[last_name]"]').value.trim().slice(0, 80),
        email: form.querySelector('[name="contact[email]"]').value.trim().toLowerCase().slice(0, 200),
        entryDate: new Date().toISOString(),
        shared: false,
        crystalAscensionMember: false
      };
      var submitButton = form.querySelector('[type="submit"]');

      setBusy(submitButton, true, 'Saving your entry…');
      setStatus(form, '', '');

      try {
        await subscribe(root, entry);
        setStoredEntry(entry);
        revealShare(form, entry);
        setStatus(form, 'You’re entered! You have 1 entry. Share and join Crystal Ascension for up to 10 more.', 'success');
      } catch (error) {
        setStatus(form, 'We couldn’t save your entry. Please check your connection and try again.', 'error');
      } finally {
        setBusy(submitButton, false);
      }
    });

    form.querySelectorAll('[data-rg-share]').forEach(function (button) {
      button.addEventListener('click', async function () {
        var panel = button.closest('[data-rg-share-panel]');
        var platform = button.getAttribute('data-rg-share');
        var url = shareUrl(root);

        if (platform === 'facebook') {
          var facebookWindow = window.open(
            'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
            'rgGiveawayShare',
            'width=720,height=560'
          );
          if (!facebookWindow) {
            setStatus(form, 'Please allow the Facebook share window, then try again.', 'error');
            return;
          }
          try {
            facebookWindow.opener = null;
          } catch (error) {}
          await recordShare(root, form, panel, 'Facebook', button);
          return;
        }

        try {
          var recordedPlatform = 'Instagram / copied link';
          if (navigator.share) {
            await navigator.share({ title: 'Royal Gems August Monthly Giveaway', text: shareText(), url: url });
            recordedPlatform = 'Instagram / device share';
          } else if (navigator.clipboard) {
            await navigator.clipboard.writeText(shareText() + ' ' + url);
            window.open('https://www.instagram.com/', 'rgGiveawayInstagram', 'noopener,noreferrer');
          } else {
            window.prompt('Copy this giveaway link for Instagram:', url);
            window.open('https://www.instagram.com/', 'rgGiveawayInstagram', 'noopener,noreferrer');
          }
          await recordShare(root, form, panel, recordedPlatform, button);
        } catch (error) {
          if (error && error.name === 'AbortError') return;
          setStatus(form, 'Copy the giveaway link, then click the Instagram share button again.', 'error');
        }
      });
    });

    var groupConfirm = form.querySelector('[data-rg-group-confirm]');
    var groupSave = form.querySelector('[data-rg-group-save]');
    if (groupConfirm && groupSave) {
      groupConfirm.addEventListener('change', function () {
        groupSave.disabled = !groupConfirm.checked;
      });
      groupSave.addEventListener('click', async function () {
        if (!groupConfirm.checked) {
          setStatus(form, 'Please confirm that you joined Crystal Ascension or are already a member.', 'error');
          return;
        }
        var panel = groupSave.closest('[data-rg-share-panel]');
        await recordCrystalAscension(root, form, panel, groupSave);
      });
    }
  }

  function initializeRoot(root) {
    root.querySelectorAll('[data-rg-entry-form]').forEach(function (form) {
      initializeForm(root, form);
    });

    var countdown = root.querySelector('[data-rg-countdown]');
    if (!countdown) return;
    var deadline = new Date(root.getAttribute('data-deadline')).getTime();
    if (!Number.isFinite(deadline)) return;

    countdown.textContent = '';
    countdown.setAttribute('role', 'timer');
    countdown.setAttribute('aria-live', 'off');
    countdown.setAttribute('aria-atomic', 'true');

    var countdownLabel = document.createElement('span');
    countdownLabel.className = 'rg-countdown__label';
    countdownLabel.textContent = 'Entries close in';
    countdownLabel.setAttribute('aria-hidden', 'true');
    countdown.appendChild(countdownLabel);

    var units = document.createElement('span');
    units.className = 'rg-countdown__units';
    units.setAttribute('aria-hidden', 'true');
    countdown.appendChild(units);

    var unitValues = {};
    [
      ['days', 'Days'],
      ['hours', 'Hours'],
      ['minutes', 'Minutes'],
      ['seconds', 'Seconds']
    ].forEach(function (definition) {
      var unit = document.createElement('span');
      unit.className = 'rg-countdown__unit';
      unit.dataset.rgCountdownUnit = definition[0];

      var value = document.createElement('strong');
      value.className = 'rg-countdown__value';
      value.dataset.rgCountdownValue = definition[0];
      value.textContent = '--';

      var label = document.createElement('small');
      label.textContent = definition[1];

      unit.appendChild(value);
      unit.appendChild(label);
      units.appendChild(unit);
      unitValues[definition[0]] = value;
    });

    function updateUnit(name, value) {
      var nextValue = String(value).padStart(2, '0');
      var element = unitValues[name];
      if (!element || element.textContent === nextValue) return;
      element.textContent = nextValue;
      element.classList.remove('is-ticking');
      void element.offsetWidth;
      element.classList.add('is-ticking');
    }

    var tickerId = null;

    function updateCountdown() {
      var remaining = Math.max(0, deadline - Date.now());
      if (remaining <= 0) {
        countdown.textContent = 'Entries are closed';
        countdown.classList.add('rg-giveaway__deadline-pill--closed');
        countdown.removeAttribute('aria-label');
        if (tickerId) window.clearInterval(tickerId);
        return;
      }
      var days = Math.floor(remaining / 86400000);
      var hours = Math.floor((remaining % 86400000) / 3600000);
      var minutes = Math.floor((remaining % 3600000) / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);

      updateUnit('days', days);
      updateUnit('hours', hours);
      updateUnit('minutes', minutes);
      updateUnit('seconds', seconds);
      countdown.setAttribute(
        'aria-label',
        days + ' days, ' + hours + ' hours, ' + minutes + ' minutes, and ' + seconds + ' seconds left to enter'
      );
    }

    updateCountdown();
    if (Date.now() < deadline) tickerId = window.setInterval(updateCountdown, 1000);
  }

  function initializePopup(popup) {
    if (!popup || deadlinePassed(popup)) return;

    var dialog = popup.querySelector('[role="dialog"]');
    var closeButton = popup.querySelector('[data-rg-popup-close]');
    var previousFocus = null;
    var hasShown = false;
    var loadedAt = Date.now();
    var closedAt = 0;

    try {
      closedAt = parseInt(localStorage.getItem(POPUP_CLOSED_KEY) || '0', 10);
      if (sessionStorage.getItem(POPUP_SESSION_KEY) === '1') return;
    } catch (error) {}
    if (closedAt && Date.now() - closedAt < 24 * 60 * 60 * 1000) return;

    function focusable() {
      return Array.prototype.slice.call(
        popup.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return element.offsetParent !== null;
      });
    }

    function show() {
      if (hasShown || !popup.hidden || deadlinePassed(popup)) return;
      hasShown = true;
      previousFocus = document.activeElement;
      popup.hidden = false;
      document.body.classList.add('rg-giveaway-popup-open');
      try {
        sessionStorage.setItem(POPUP_SESSION_KEY, '1');
      } catch (error) {}
      window.setTimeout(function () {
        if (closeButton) closeButton.focus();
      }, 60);
    }

    function close() {
      popup.hidden = true;
      document.body.classList.remove('rg-giveaway-popup-open');
      try {
        localStorage.setItem(POPUP_CLOSED_KEY, String(Date.now()));
      } catch (error) {}
      if (previousFocus && previousFocus.focus) previousFocus.focus();
    }

    if (closeButton) closeButton.addEventListener('click', close);
    popup.addEventListener('click', function (event) {
      if (event.target === popup) close();
    });
    document.addEventListener('keydown', function (event) {
      if (popup.hidden) return;
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab') return;
      var elements = focusable();
      if (!elements.length) return;
      var first = elements[0];
      var last = elements[elements.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener(
      'scroll',
      function () {
        if (Date.now() - loadedAt >= 12000 && window.scrollY >= 420) show();
      },
      { passive: true }
    );
    document.addEventListener('mousemove', function (event) {
      if (Date.now() - loadedAt >= 12000 && event.clientY <= 12 && window.innerWidth > 768) show();
    });
    window.setTimeout(show, 26000);
  }

  document.querySelectorAll('[data-rg-giveaway-root]').forEach(initializeRoot);
  initializePopup(document.querySelector('[data-rg-giveaway-popup]'));
})();
